import React from "react";
import Marquee from "react-fast-marquee";
import { TRUSTED } from "../data";

export const Trusted = () => (
  <section data-testid="trusted-section" className="relative py-14 border-b border-white/10 bg-black">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <p className="text-center text-[10px] md:text-xs uppercase tracking-[0.35em] text-[#F2F2F2]/40 mb-8">
        Played at · Trusted by
      </p>
    </div>
    <Marquee speed={30} gradient gradientColor="#000000" gradientWidth={80} autoFill>
      {TRUSTED.map((name, i) => (
        <div key={i} className="flex items-center mx-10 md:mx-14">
          <span
            data-testid={`trusted-${i}`}
            className="font-display text-lg md:text-2xl uppercase text-[#F2F2F2]/55 hover:text-[#F2F2F2] transition-colors duration-300 tracking-tight"
          >
            {name}
          </span>
        </div>
      ))}
    </Marquee>
  </section>
);

export default Trusted;
